// extracted by mini-css-extract-plugin
export default {"image":"Q1-z","loaded":"R1-z"};